var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFireFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,24h-.057c-5.482,0-9.943-4.486-9.943-10,0-1.929,.666-4.07,1.874-6.031,.471-.765,1.373-1.126,2.241-.896,.869,.229,1.474,.987,1.505,1.885,.096,2.74,.753,6.014,3.338,6.043,1.081,.009,1.937-.747,2.027-1.727,.094-1.026-.277-1.83-.746-2.847-.552-1.2-1.24-2.692-1.24-4.901,0-1.707,.345-3.412,.687-4.345C11.941,.488,12.542,.033,13.256-.008c.739-.04,1.414,.367,1.753,1.042,.802,1.595,1.938,3.069,3.036,4.495,1.972,2.562,4.011,5.211,3.956,8.487,0,5.464-4.483,9.95-9.994,9.983h-.006Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireFill);
export default __webpack_public_path__ + "static/media/fire-fill.c3767a8693459b8d9a2173c5d67e0d0b.svg";
export { ForwardRef as ReactComponent };